import styled from 'styled-components'

import theme from 'style/theme'

export default styled.div`
  height: 100%;
  box-shadow: 0 10px 20px 0 rgba(217, 167, 141, 0.15);
  border: solid 1px #ffdfc7;
  border-radius: 20px;
  overflow: hidden;
  background: ${theme.white};

  .image-block {
    img {
      aspect-ratio: 1 / 1;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .info-block {
    padding: 14px 8px;

    .title-block {
      text-align: center;
      .text-title {
        color: ${theme.darkGray};
      }
    }
  }
`
